import Token from '@/utils/Token';

export default {
    parse(data) {
        return data;
    },
    contratoPreenchimento(contratoId, params) {
        //return `/api/arquivo/contrato/preenchimento/${contratoId}`;
       return axios.post(`/api/arquivo/contrato/preenchimento/${contratoId}`, params, Token.getHeader());
    },
    contratoAssinatura(contratoId, params) {
        // return `/api/arquivo/contrato/assinatura/${contratoId}`;
        return axios.post(`/api/arquivo/contrato/assinatura/${contratoId}`, params, Token.getHeader());
    },
    contratoEvidencia(contratoId,params) {
        //return `/api/arquivo/contrato/evidencia/${contratoId}`;
        return axios.post(`/api/arquivo/contrato/evidencia/${contratoId}`, params, Token.getHeader());
    },
    // contaCarne(contratoId) {
    //     return `/api/arquivo/conta/carne/${contratoId}`;
    // },
    contaCarne(contratoId,params) {
        return axios.post(`/api/arquivo/conta/carne/${contratoId}`, params, Token.getHeader());
    },
    // contaBoleto(contaId) {
    //     return `/api/arquivo/conta/boleto/${contaId}`;
    // },
    contaBoleto(contaId, params) {
        return axios.post(`/api/arquivo/conta/boleto/${contaId}`, params, Token.getHeader());
    },
    // contaComprovante(contaId) {
    //     return `/api/arquivo/conta/comprovante/${contaId}`;
    // },
    contaComprovante(contaId, params) {
        return axios.post(`/api/arquivo/conta/comprovante/${contaId}`, params, Token.getHeader());
    },
    upload(params) {
        // return `/api/arquivo/upload`;
        return axios.post(`/api/arquivo/upload`, params, Token.getHeader());
    },
    cancelamentoAnexo(cancelamentoId, params) {
        return axios.post(`/api/arquivo/cancelamento/${cancelamentoId}/anexo`, params, Token.getHeader());
    },
    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/arquivo/${id}${params}`, Token.getHeader());
    },
    view(id, params = '') {
        if (params) params = `?${params}`;
        return axios.get(`/api/arquivo/view/${id}${params}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/arquivo/list${params}`, Token.getHeader());
    },
    delete(id) {
        return axios.delete(`/api/arquivo/${id}`, Token.getHeader());
    },
}
